import { createFileRoute, Outlet } from "@tanstack/react-router";
import PageLayout from "@/components/layout/PageLayout";

export const Route = createFileRoute("/events")({
	component: () => (
		<PageLayout>
			<Outlet />
		</PageLayout>
	),
});
